export default __webpack_public_path__ + "static/media/party-horn.b8134db5.svg";